import React from 'react'
import './contactus.css'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/Large-screens/13.png"


const contactus = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
  )
}

export default contactus